import type { AxiosError, AxiosRequestConfig, AxiosResponse, CancelTokenSource } from 'axios';
import axios from 'axios';

import { GENERAL_ERROR_MESSAGE } from '../../../constants';
import { toCamelCase } from '../../../utils/transform/toCamelCase';
import campaignGraphqlManager from '../index';
import { UPLOAD_CSV_ENDPOINT } from './constants';
import type { SavedScheduleResult, UploadCSVErrorResponse } from './types';
import type { UploadCSVAxiosErrorResponse } from './types';

function makeErrorInfoFromResponse(error: unknown): Pick<UploadCSVErrorResponse, 'name' | 'message'> {
  if (axios.isCancel(error) || !axios.isAxiosError<UploadCSVAxiosErrorResponse>(error) || !error.response?.data.error) {
    return {
      name: 'Error',
      message: GENERAL_ERROR_MESSAGE,
    };
  }

  return { message: error.response.data.error.message, name: error.response.data.error.name };
}

export const customPacingUploadCSV = async (
  file: File,
  setPercentUploaded: (percent: number) => void,
  cancelTokenSource: CancelTokenSource
): Promise<SavedScheduleResult> => {
  const formData = new FormData();

  formData.append('file', file);

  const config: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    cancelToken: cancelTokenSource.token,
    onUploadProgress: (event: ProgressEvent) => {
      const percent = Math.round((event.loaded * 100) / event.total);
      setPercentUploaded(percent);
    },
  };

  return campaignGraphqlManager
    .post(UPLOAD_CSV_ENDPOINT, formData, config)
    .then((response: AxiosResponse<SavedScheduleResult>) => toCamelCase(response.data) as SavedScheduleResult)
    .catch((error: AxiosError<UploadCSVAxiosErrorResponse>) => Promise.reject(makeErrorInfoFromResponse(error)));
};
